import { FileText, ImageIcon, Download, Wrench } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const DOCS = [
  {
    key: "fiche",
    file: "/docs/Fiche_Technique_Smart_Film_LCD.pdf",
    download: "smartxglass-fiche-technique-smart-film-lcd.pdf",
    Icon: FileText,
    type: "PDF",
  },
  {
    key: "noticeVisual",
    file: "/docs/Notice_Pose_Etapes_Visuelles.png",
    download: "smartxglass-notice-pose-etapes.png",
    Icon: ImageIcon,
    type: "PNG",
  },
  {
    key: "noticeText",
    file: "/docs/Notice_Pose_Texte.png",
    download: "smartxglass-notice-pose-texte.png",
    Icon: Wrench,
    type: "PNG",
  },
];

export const TechnicalDocs = () => {
  const { t } = useLanguage();

  return (
    <section
      id="documents"
      data-testid="technical-docs-section"
      className="py-20 sm:py-28 bg-[#0a0a0a] relative overflow-hidden"
    >
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[80%] hairline" />

      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-12">
        <header className="mb-12 sm:mb-16 max-w-2xl">
          <span className="text-xs uppercase tracking-[0.32em] text-[#d89557]">
            {t("docs.label")}
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#f4ede0] mt-4 leading-[1.1]">
            {t("docs.title1")}{" "}
            <span className="copper-text italic">{t("docs.title2")}</span>
          </h2>
          <p className="mt-5 text-sm sm:text-base text-[#cbc1ad] leading-relaxed">
            {t("docs.intro")}
          </p>
        </header>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {DOCS.map(({ key, file, download, Icon, type }) => (
            <a
              key={key}
              href={file}
              download={download}
              data-testid={`doc-${key}`}
              className="group block p-6 sm:p-7 border border-[#2a2422] bg-[#0d0c0b] hover:border-[#b87333]/60 hover:bg-[#1a1614] transition-all duration-300"
            >
              <div className="flex items-start justify-between mb-5">
                <div className="w-12 h-12 border border-[#b87333]/40 bg-[#b87333]/5 flex items-center justify-center group-hover:bg-[#b87333]/15 transition">
                  <Icon className="w-5 h-5 text-[#d89557]" strokeWidth={1.5} />
                </div>
                <span className="text-[10px] uppercase tracking-[0.28em] text-[#7a716a] group-hover:text-[#d89557] transition">
                  {type}
                </span>
              </div>

              <h3 className="font-display text-lg sm:text-xl text-[#f4ede0] mb-2 leading-tight">
                {t(`docs.items.${key}.title`)}
              </h3>
              <p className="text-sm text-[#cbc1ad] leading-relaxed mb-6">
                {t(`docs.items.${key}.desc`)}
              </p>

              <div className="flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-[#d89557] group-hover:gap-3 transition-all">
                <Download className="w-3.5 h-3.5" />
                <span>{t("docs.download")}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
